export const GROUPS_DROPPABLE_ID = 'groups';

export const TARGET_LIST_ITEM_DATE_FORMAT = "MMM DD YY'";

export const TARGET_SAVE_DIV_ID = 'TARGET_SAVE_DIV';

export const GROUPS_SCROLLER_ID = 'groups-scroller';
